"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _connectedReactRouter = require("connected-react-router");
var _history = _interopRequireDefault(require("../../history.js"));
var _boilerplate = require("../../reducers/boilerplate.js");
var _cccisdApollo = require("cccisd-apollo");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdSound = require("cccisd-sound");
var _cccisdReactQuery = require("cccisd-react-query");
var _reactRedux = require("react-redux");
var _AutoLogout = _interopRequireDefault(require("./AutoLogout.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable import/no-unresolved */
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var queryClient = new _cccisdReactQuery.QueryClient({
  defaultOptions: {
    queries: {
      // it fixed the Mac Chrome issue when navigator.onLine is false for some reason
      networkMode: 'always'
    }
  }
});
var App = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function App() {
    var _this;
    _classCallCheck(this, App);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, App, [].concat(args));
    _defineProperty(_this, "listenGlobalClick", function () {
      document.addEventListener('click', _this.captureGlobalClick);
    });
    _defineProperty(_this, "unlistenGlobalClick", function () {
      document.removeEventListener('click', _this.captureGlobalClick);
    });
    _defineProperty(_this, "captureGlobalClick", function () {
      _this.props.store.dispatch((0, _boilerplate.captureGlobalClick)());
      _this.unlistenGlobalClick();
    });
    return _this;
  }
  _inherits(App, _React$Component);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _Appdefs$app;
      this.listenGlobalClick();

      // Preload fake audio to allow autoplay other sounds
      (0, _cccisdSound.preload)('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU2LjM2LjEwMAAAAAAAAAAAAAAA//OEAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAEAAABIADAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV6urq6urq6urq6urq6urq6urq6urq6urq6v////////////////////////////////8AAAAATGF2YzU2LjQxAAAAAAAAAAAAAAAAJAAAAAAAAAAAASDs90hvAAAAAAAAAAAAAAAAAAAA//MUZAAAAAGkAAAAAAAAA0gAAAAATEFN//MUZAMAAAGkAAAAAAAAA0gAAAAARTMu//MUZAYAAAGkAAAAAAAAA0gAAAAAOTku//MUZAkAAAGkAAAAAAAAA0gAAAAANVVV');
      if (Appdefs !== null && Appdefs !== void 0 && (_Appdefs$app = Appdefs.app) !== null && _Appdefs$app !== void 0 && _Appdefs$app.isQuestFreeTrial && Fortress.auth()) {
        (0, _cccisdNotification["default"])({
          type: 'info',
          message: 'You are using Quest as a trial. Some features may not be available.',
          duration: 7000
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlistenGlobalClick();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdReactQuery.QueryClientProvider, {
        client: queryClient
      }, /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
        store: this.props.store
      }, /*#__PURE__*/_react["default"].createElement(_cccisdApollo.ApolloProvider, {
        client: _cccisdApollo.client
      }, /*#__PURE__*/_react["default"].createElement(_connectedReactRouter.ConnectedRouter, {
        history: _history["default"],
        basename: "/".concat(Boilerplate.settings.currentUri)
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_AutoLogout["default"], null), this.props.children)))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(App, "propTypes", {
  store: _propTypes["default"].object,
  children: _propTypes["default"].node
});